import { styled } from '../../shared/theme'

export const Container = styled.header`
  position: relative;
  overflow: hidden;
  width: 100%;
  min-height: 460px;
  background-color: transparent;
  z-index: 1;
  isolation: isolate;
  height: ${props => props.height};
`
